module.exports=[
  "artist",
  "echo location employee",
  "manager",
  "other",
  "production assistant",
  "promoter/buyer",
  "tour manager"
]
